import { WidgetType } from '../..'
import { DOMUtils } from '../../../../utils/dom'
import { AbstractWidgetAdapter, IWidgetAdapter } from '../../../widgets/adapters/adapter'

export class FlyerCity extends AbstractWidgetAdapter implements IWidgetAdapter {

    public static DOM = {
        attrs: {
            modId: 'data-mod-id',
            pageType: 'data-page-type',
            urlParam: 'data-url-param'
        }
    }

    public constructor(public el: Element, public adLight = false) {
        super(el, adLight)
    }

    /**
     * Load 3rd party javascript with widget data
     */
    public loadData(): void {
        const modId = this.el.getAttribute(FlyerCity.DOM.attrs.modId)
        const urlParam = this.el.getAttribute(FlyerCity.DOM.attrs.urlParam)
        const scriptSource = this.getScriptSource(urlParam, this.isFullPage())

        // create element with id
        this.el.id = `${modId}`

        // only load the script if there is a mod ID to load
        if (modId) {
            DOMUtils.loadScript(scriptSource)
        }
    }

    /**
     * Remove flyercity ads container
     */
    public removeWidgetContainer(): void {
        if ( !this.isFullPage() ) {
            DOMUtils.nodes(document.querySelectorAll(`.js-widget-${WidgetType.FLYERCITY}`))
            .forEach((el: Element) => el.remove())
        }
    }

    /**
     * Returns scriptSource
     * @returns string
     * @param string urlParam
     * @param boolean isFullPage
     */
    public getScriptSource(urlParam: string, isFullPage: boolean): string {
        // set the default script
        let scriptSource = `https://api.flyertown.ca/${urlParam}/flyertown_module.js`
        if (isFullPage) {
            scriptSource = `https://api.flyertown.ca/embed_iframe/v3/${urlParam}/iframe.js`
        }
        return scriptSource
    }

    /**
     * Returns True is pageType is full
     */
    private isFullPage(): boolean {
        const pageType = this.el.getAttribute(FlyerCity.DOM.attrs.pageType)
        return pageType === 'full'
    }

}
